import { render, staticRenderFns } from "./FormExterno.vue?vue&type=template&id=2e205442"
import script from "./FormExterno.vue?vue&type=script&lang=js"
export * from "./FormExterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports